import { DateTime } from 'luxon';
import { z } from 'zod';

// ─── the one offset-bearing instant rule ─────────────────────────────────────
//
// The single declaration of "an ISO-8601 instant" for this contract, shared by
// the request bodies, the response payloads AND the staff list cursor. Those
// three previously hand-rolled the identical regex and Luxon check; a
// tightening applied to one would not have reached the others.
//
// Luxon rather than `Date.parse` (ADR-096 Rule 5): `Date.parse` accepts
// '03/15/2026', 'December 17, 1995 03:24:00' and bare date strings, several of
// which the host's locale decides the meaning of.

/**
 * Matches an ISO-8601 string that carries a time AND an explicit UTC offset.
 *
 * Luxon alone is not enough: it accepts `'2026'` and `'2026-09-15'` as valid
 * ISO, and both would land as local midnight in whatever zone the Lambda
 * happens to resolve. A point on the timeline needs the offset stated.
 */
export const NRT_ISO_INSTANT_WITH_OFFSET = /T.*(Z|[+-]\d{2}:?\d{2})$/;

/** An ISO-8601 instant carrying a UTC offset. */
export const nrtIsoInstantSchema = z
  .string()
  .refine(
    (value) =>
      NRT_ISO_INSTANT_WITH_OFFSET.test(value) && DateTime.fromISO(value, { setZone: true }).isValid,
    'must be an ISO-8601 instant carrying a UTC offset',
  );
